import React, { useState } from "react";
import {
  Button,
  Form,
  FormGroup,
  FormFeedback,
  Spinner,
  Input,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { CustomAlertMessage } from "../../../functions/CustomFunctions";
import { REQUIRED_DOCUMENT, UPDATE_REQDOC } from "../../../constants/ApiPaths";
import { useSnackbar } from "notistack";
import { authHeader } from "../../../functions/CoreFunctions";
import API from "../../../redux/actions/API";
export default function ReqDocModal(props) {
  const defaultDocValues = {
    documentName: "",
    documentDescription: "",
    isMandatory: false,
    licenseRequiredDocId: "",
  };
  const {
    reqmodal,
    SingleDoc,
    reqtoggle,
    updateDocFlag,
    categoryId,
    sucesscallback,
  } = props;
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setloading] = useState(false);
  const validationSchema = Yup.object({
    documentName: Yup.string().trim().required("Document Name is required"),
  });

  const {
    handleSubmit,
    handleChange,
    handleBlur,
    resetForm,
    values,
    errors,
    touched,
  } = useFormik({
    initialValues: SingleDoc || defaultDocValues,
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => RequiredDocument(values),
  });
  let RequiredDocument = async () => {
    setloading(true);
    const config = {
      method: updateDocFlag ? "POST" : "PUT",
      url: updateDocFlag ? REQUIRED_DOCUMENT : UPDATE_REQDOC,
      headers: authHeader(),
      data: updateDocFlag
        ? {
            ...values,
            categoryId: categoryId,
          }
        : values,
    };
    try {
      const response = await API(config);
      const { status,  message } = response.data;
      if (status === "Success") {
        CustomAlertMessage(message, "success", enqueueSnackbar);
        sucesscallback();
        reqtoggle();
        resetForm({});
        setloading(false);
      }
    } catch (error) {
      const { data } = error.response;
      CustomAlertMessage(data.message, "error", enqueueSnackbar);
    } finally {
      setloading(false);
    }
  };

  return (
    <div>
      <Modal isOpen={reqmodal} toggle={() => reqtoggle(resetForm({}))}>
        <ModalHeader toggle={reqtoggle}>
          {updateDocFlag ? "Add Document" : "Update Document"}
        </ModalHeader>
        <Form onSubmit={handleSubmit}>
          <ModalBody>
            <FormGroup>
              <Label>Document Name</Label>
              <Input
                type="text"
                name="documentName"
                placeholder="Enter Document Name"
                onChange={handleChange}
               
                value={values?.documentName || ""}
                onBlur={handleBlur}
                invalid={
                  errors.documentName && touched.documentName ? true : false
                }
              />
              <FormFeedback>
                {errors.documentName && touched.documentName
                  ? errors.documentName
                  : ""}
              </FormFeedback>
            </FormGroup>
            <Label>Document Description</Label>
            <Input
              type="text"
              onChange={handleChange}
              placeholder="Enter Documen tDescription"
              value={values?.documentDescription || ""}
              name="documentDescription"
            />
            <FormGroup check>
              <Label check>
                <Input
                  type="checkbox"
                  onChange={handleChange}
                  checked={values?.isMandatory}
                  name="isMandatory"
                />{" "}
                Required
              </Label>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" type="submit">
              {" "}
              {loading ? <Spinner /> : ""} {updateDocFlag ? "Create" : "Update"}{" "}
            </Button>{" "}
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
}
